(function() {
  console.log('[Related Products] Script loaded');

  const MAX_ITEMS = 6;

  // Aktuelle Sprach-Root von Langify holen (z.B. "/en", "/fr", "" für Standardsprache)
  var LANGIFY_ROOT_URL = '';
  if (window.langify && window.langify.locale && window.langify.locale.root_url) {
    LANGIFY_ROOT_URL = window.langify.locale.root_url !== '/' ? window.langify.locale.root_url : '';
  }

function renderRecommendations(products, container, track, productId) {
  if (!products || products.length === 0) {
    console.log('[Related Products] No valid products to render for product', productId);
    container.style.display = 'none';
    return;
  }

  let html = '';

  products.forEach(product => {
    // --- Preis ---
    const priceCents =
      product.price ||
      (product.variants && product.variants[0] && product.variants[0].price);

    let comparePriceCents =
      product.compare_at_price ||
      (product.variants && product.variants[0] && product.variants[0].compare_at_price);

    if (!priceCents) {
      console.log('[Related Products] Skipping product without price:', product);
      return;
    }

    const priceCentsNum = Number(priceCents);
    const comparePriceCentsNum = comparePriceCents != null ? Number(comparePriceCents) : null;

    if (!comparePriceCentsNum || comparePriceCentsNum <= priceCentsNum) {
      comparePriceCents = null;
    }

    const price = (priceCentsNum / 100).toFixed(2).replace('.', ',');
    const comparePrice = comparePriceCents
      ? (Number(comparePriceCents) / 100).toFixed(2).replace('.', ',')
      : null;

    // --- Bild ---
    const imageObj = product.featured_image || (product.images && product.images[0]);
    let imageUrl = null;

    if (typeof imageObj === 'string') {
      imageUrl = imageObj;
    } else if (imageObj && typeof imageObj === 'object') {
      imageUrl = imageObj.url || imageObj.src;
    }

    if (!imageUrl) {
      console.log('[Related Products] No image found for product, skipping:', product.title, imageObj);
      return;
    }

    if (!product.variants || product.variants.length === 0) {
      console.log('[Related Products] No variants for product, skipping:', product.title);
      return;
    }

    html += `
      <div class="related-notification__item">
        <a href="${product.url}" class="related-notification__image-wrapper">
          <img src="${imageUrl}"
               alt="${product.title}"
               class="related-notification__image"
               loading="lazy">
        </a>

        <div class="related-notification__details">
          <a href="${product.url}" class="related-notification__product-title">
            ${product.title.length > 40 ? product.title.substring(0, 40) + '...' : product.title}
          </a>

          <div class="related-notification__price">
            ${
              comparePrice
                ? `<span class="related-notification__price--sale">${price} €</span>
                   <span class="related-notification__price--compare">${comparePrice} €</span>`
                : `<span>${price} €</span>`
            }
          </div>
        </div>
      </div>
    `;
  });

  if (!html) {
    console.log('[Related Products] No valid products to render after filtering for product', productId);
    container.style.display = 'none';
    return;
  }

  track.innerHTML = html;
  container.style.display = 'block';
  container.dataset.loaded = 'true';

  // === Desktop-Nav: Pfeile aktivieren ===
  const prevBtn = container.querySelector('[data-nav="prev"]');
  const nextBtn = container.querySelector('[data-nav="next"]');


if (prevBtn && nextBtn) {

  const firstItem = track.querySelector('.related-notification__item');
  const itemWidth = firstItem ? firstItem.offsetWidth : 200;
  const scrollAmount = itemWidth + 12;

  if (!prevBtn.dataset.navInitialized) {

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    // markieren, damit nicht doppelt initialisiert wird
    prevBtn.dataset.navInitialized = 'true';
    nextBtn.dataset.navInitialized = 'true';
  }
}

  console.log('[Related Products] ✅ Rendered successfully for product', productId);
}

  function loadRecommendationsForProduct(productId) {
    console.log('[Related Products] Attempting to load for product:', productId);

    const container = document.getElementById('related-notification-' + productId);
    if (!container) {
      console.log('[Related Products] Container not found for product', productId);
      return false;
    }

    if (container.dataset.loaded === 'true') {
      console.log('[Related Products] Already loaded for product', productId);
      return true;
    }

    const track = container.querySelector('[data-track]');
    if (!track) {
      console.log('[Related Products] Track not found');
      return false;
    }

    console.log('[Related Products] Elements found, fetching complementary recommendations...');

    // 1. complementary holen
return fetch(`${LANGIFY_ROOT_URL}/recommendations/products.json?product_id=${productId}&limit=${MAX_ITEMS}&intent=complementary`)
      .then(response => response.json())
      .then(data => {
        let products = (data && data.products) || [];
        console.log('[Related Products] Complementary found:', products.length);

        // Wenn schon genug: direkt rendern
        if (products.length >= MAX_ITEMS) {
          renderRecommendations(products.slice(0, MAX_ITEMS), container, track, productId);
          return;
        }

        const missing = MAX_ITEMS - products.length;

        console.log('[Related Products] Fetching related as fallback, missing:', missing);

        // 2. Fallback: related holen
        return fetch(`${LANGIFY_ROOT_URL}/recommendations/products.json?product_id=${productId}&limit=${missing}&intent=related`)
          .then(response => response.json())
          .then(data2 => {
            let more = (data2 && data2.products) || [];

            // Duplikate (gleiche IDs) rausfiltern
            more = more.filter(p => !products.some(existing => existing.id === p.id));

            console.log('[Related Products] Related fallback found:', more.length);

            products = products.concat(more).slice(0, MAX_ITEMS);

            renderRecommendations(products, container, track, productId);
          });
      })
      .catch(error => {
        console.error('[Related Products] ❌ Error:', error);
        container.style.display = 'none';
      });
  }

  // Observer für dynamische Elemente
  const observer = new MutationObserver(function() {
    const containers = document.querySelectorAll('[id^="related-notification-"]');
    containers.forEach(container => {
      if (container.dataset.loaded === 'true') return;

      const productId = container.id.replace('related-notification-', '');
      console.log('[Related Products] (Observer) Found container for product:', productId);
      loadRecommendationsForProduct(parseInt(productId, 10));
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Initialer Scan nach Page-Load
  setTimeout(function() {
    const containers = document.querySelectorAll('[id^="related-notification-"]');
    console.log('[Related Products] Initial scan found', containers.length, 'containers');
    containers.forEach(container => {
      if (container.dataset.loaded === 'true') return;

      const productId = container.id.replace('related-notification-', '');
      loadRecommendationsForProduct(parseInt(productId, 10));
    });
  }, 500);

})();
